export const SMALL_ROWS_PER_PAGINATION_OPTIONS = [10, 25, 50]
export const MEDIUM_ROWS_PER_PAGINATION_OPTIONS = [25, 50, 75]